import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { sendInvitations } from '../../api/admin';
import { InvitationForm } from '../../components';
import AdminNav from '../../components/nav/AdminNav';

const SendInvites = () => {
    const { user } = useSelector((state) => ({ ...state }));
    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState('')

    const handleSubmit = e => {
        e.preventDefault()
        setLoading(true)
        sendInvitations(user.token, user._id, email)
            .then(res => {
                setEmail('')
                toast.success("Invitation sent successfully")
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
                setLoading(false)
            })
    }

    return (<div className="send-invites">
        <div className="row">
            <div className="col-md-2">
                <AdminNav />
            </div>
            <div className="col-md-10">
                {loading ? <h1>loading</h1> : <InvitationForm setEmail={setEmail} email={email} handleSubmit={handleSubmit} />}
            </div>
        </div>
    </div>);
};

export default SendInvites;